import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BaseFormViewer, CustomTitle, Form, FormCreatorService, FormSectionPageComponent, IFormOptions, VisorComponent } from 'lib-base';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { StepsModule } from 'primeng/steps';
import { FormularioService } from '../../../../services/database/formulario.service';
import saveAs from 'file-saver';

@Component({
  selector: 'app-actividad-formulario',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule, FormSectionPageComponent, VisorComponent,
    ButtonModule, CardModule, StepsModule, TranslateModule, CustomTitle
  ],
  providers: [FormCreatorService],
  styleUrl: './../../../../components/form-builder-components/form-viewer/form-viewer.component.scss',
  template: `
  <app-visor/>
  <div *ngIf="this.fc.Pages.length > 1" class="mb-2">
    <p-steps [model]="pageItems" [activeIndex]="fc.activeIndex"></p-steps>
  </div>

  <div class="form-panel-preview">
    <CustomTitle *ngIf="fc.Form.title" [title]="fc.Form.title" styleClass="font-principal font-20 title-blue border-round
                  ml-1 font-medium px-5 py-3 w-full bg-gray-200" />
    <div class="content formgrid p-fluid">
      <form #form="ngForm" [formGroup]="fc.FormGroup">
        <ng-container *ngIf="fc.activePage">
          <app-form-section-page [page]="fc.activePage" [pageIndex]="fc.activeIndex"
            [formGroup]="fc.getPageFormGroup(fc.activePage.name)" [isDesigner]="isDesigner">
          </app-form-section-page>
        </ng-container>
      </form>
    </div>
    <div class="footer">
      <div>
        <p-button *ngIf="!isFirstPage" [label]="'form.button.atras' | translate" (onClick)="prevPage()"
          icon="pi pi-angle-left"></p-button>
      </div>
    </div>
  </div>
  `
})
export class ActividadFormularioComponent extends BaseFormViewer implements OnInit {

  @Input() options !: IFormOptions;
  radicado ?: string;
  @ViewChild(VisorComponent) visorDialog !: VisorComponent;
  
  constructor(public override fc: FormCreatorService, private _fs: FormularioService) {
    super(fc);
    this.fc.downloadFileEvent.subscribe(([radicado, fileId, fileName, saveFile]: [string, string, string, boolean]) => {
      this.onDownloadFile(radicado, fileId, fileName, saveFile);
    });
  }

  ngOnInit(): void {
    this.fc.setOptions(this.options);
  }

  public loadForm(formId: number, formVersion: number, respuesta?: string): void {
    this._fs.findByIdAndVersion(formId, formVersion).subscribe({
        next: (response: Form) => {
          this.fc.loadForm(response, this.radicado);
          if(respuesta){
            this.fc.loadRespuesta(respuesta);
          }
        }
      });
  }

  submit() {
    if (!this.onSubmitForm) return;
    //Validate and get the subform values
    this.fc.Form.subForm.forEach((subforms, name) => {
      subforms.forEach(subform => {
        subform.pages.forEach(page => {
          page.submitted = true;
        });
      });
    });
    //Validate current form
    this.fc.Pages[this.fc.activeIndex].submitted = true;
    if(!this.fc.pagesFormGroup?.valid) return;

    const formValues = this.fc.Form.getFormValues();
    const dataString = JSON.stringify(formValues)    
    this.onSubmitForm(dataString);
  }

  clearPage() {
    this.fc.clearCurrentPage();
  }
  
  onDownloadFile(radicado: string, fileId: string, fileName: string, saveFile: boolean) {
    this._fs.downloadFormFile(radicado, fileId).subscribe({
      next: (response: Blob) => {
        if (response.size > 0) {
          if (saveFile)
            saveAs(response, fileName);
          else
            this.visorDialog.showDialog(response);
        }
      }
    });
  }
}
